import * as yup from "yup";

export const updateUploadValidation = yup.object({
  content: yup.string().required("Content is required"),
});
